export default __webpack_public_path__ + "static/media/icon-close.ee8191d2.svg";